import { Pusher } from "./Pusher";
export async function loadExternalPushInteraction(engine, refresh = true) {
    await engine.addInteractor("externalPush", (container) => new Pusher(container), refresh);
}
export * from "./Options/Classes/Push";
export * from "./Options/Interfaces/IPush";
